<template>
  <div id='remind' ref="remind">
    <template v-if="flag==1">
      
      <el-tabs @tab-click="handleTab" v-model="params.notificationType">
        <el-tab-pane :label="item.name" class="notice" :name="item.id" v-for="(item,index) in tabsData" :key="item+index">
          <el-row v-if="params.notificationType !='3'">
            筛选：
            <el-select v-model="params.readDto" placeholder="请选择" @change="filterreadDto()" filterable clearable>
              <el-option v-for="(item, index) in readDtoOptions" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-row>
          <el-table :data="tableData" stripe tooltip-effect="dark" style="width: 100%" class="remindTable" >
            <el-table-column slot="empty">
              <loading v-if="tableEmptyText == ''"></loading>
              <p v-else-if="tableEmptyText == '暂无数据'">暂无数据</p>
            </el-table-column>
            <el-table-column :label="item.columnOne" prop="title" class="title">
              <template slot-scope="scope">
                <el-link :style="scope.row.unread==0?'color: #000;':'color: #999;'" @click="goToCont(scope.row)" >{{scope.row.title}}</el-link>
              </template>
            </el-table-column>
            <el-table-column :label="item.columnTwo" prop="pressTime" class="time">
              <template slot-scope="scope">
                <span :style="scope.row.unread==0?'color: #000;':'color: #999;'" >{{scope.row.pressTime?scope.row.pressTime:(scope.row.releaseTime?scope.row.releaseTime:scope.row.updateTime)}}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
      <el-pagination @current-change="handleCurrent" :current-page.sync="params.pageNumber" :page-size="params.pageSize" layout="total, prev, pager, next" :total="total">
      </el-pagination>
     
    </template>
    <template v-if="flag==2">
      <el-row class="header" style="margin-top:20px;">
        <span class="draftBox" @click="goBackRemind"><img src="@/assets/img/back.png" alt="">返回</span>
      </el-row>
      <el-divider></el-divider>
      <el-row class="contTitle" v-if="contData">{{contData.title}}</el-row>
      <el-row v-if="contData?contData.content:''" class="contCont" v-html="contData.content"></el-row>
      <el-row v-if="contData?contData.url:''" class="contCont" >
        <span  @click="toLinkUrl()">{{contData.url}}</span>
      </el-row>
    </template>
  </div>
</template>
<script>
import { findNoticeList, findNoticeById, findArticleInfo,findArticleInfoList  } from '@/api/index'
// import { mapState } from 'vuex'
import loading from '@/components/Loading.vue'

export default {
  data() {
    return {
      readDtoOptions: [{
        value: null,
        label: '全部'
      }, {
        value: 0,
        label: '未读'
      }, {
        value: 1,
        label: '已读'
      }],
      
      total: 0, //总条数
      flag: 1,   // 1 提醒页面  2 详情页面
      toDoData: [],
      toDoDataAll: [],
      tableData: [],
      remindData: [],
      params: {
        notificationType: '1',
        pageNumber: 1,
        pageSize: 10,
        readDto:null,
        sort:'desc',
        sortFieldType: 2
      },
      tabsData: [
        {
          name: '公告',
          id: '1',
          columnOne: '公告标题',
          columnTwo: '公告时间',
        },
        {
          name: '提醒',
          id: '2',
          columnOne: '提醒标题',
          columnTwo: '提醒时间',
        },
        {
          name: '信用动态',
          id: '3',
          columnOne: '标题',
          columnTwo: '时间',
        }

      ],
      contData: {
        title: '',
        content: ''
      },
      remindNum: 0,
      outDataTimer: null,
      tableTimer: null,
      tableEmptyText:''
    }
  },
  created() {
    this.init()
    // setTimeout(() => {
    //   this.toDoDataAll = JSON.parse(sessionStorage.getItem('toDoDataAll'))
    //   this.dataPagination(this.toDoDataAll);
    // }, 800);

  },
  // destroyed() {
  //   clearTimeout(this.outDataTimer)
  //   clearTimeout(this.tableTimer)
  // },
  mounted() {
    
  },
  components: {
    loading
  },
  methods: {
    // 筛选已读未读
    filterreadDto(){
      this.init()
    },
    toLinkUrl(){
      window.open(this.contData.url)
    },
    async init() {
      if (this.params.notificationType == '2') {
        this.params.messageState = 1
      } else{
        this.$delete(this.params,'messageState')
      }
      const { data } = await findNoticeList(this.params)
      if (data.code != 0) return
      if(data.sysNoticeList.length == 0){
        this.tableEmptyText = '暂无数据'
      }
      this.tableData = JSON.parse(JSON.stringify(data.sysNoticeList))
      this.total = data.total
      
      // 解决点击home公告栏单条数据去往公告详情已读未更新问题
      if (this.$route.query.name == 'detail') {
        this.$parent.$parent.$parent.getTipsData()
      }
    },
    async getCreditNewsData(){
      var param = {
        number: this.params.pageNumber,
        size: this.params.pageSize
      }
      const { data } = await findArticleInfoList(param)
      if (data.code != 0) return
      this.tableData = JSON.parse(JSON.stringify(data.data.records))
      this.total = data.data.total
    },
    handleTab(val) {
      this.params.pageNumber = 1
      this.params.notificationType = val.name
      if(val.name == '3'){
        this.getCreditNewsData()
      }else{
        this.params.readDto = null
        this.init()
      }
    },
    
    handleCurrent(val) {
      this.params.pageNumber = val;
      if(this.params.notificationType == '3'){
        this.getCreditNewsData()
      }else{
        this.init();
      }
      
    },
    
    async goToCont(row) {
      this.flag = 2
      if (row.saveType) {
        const { data } = await findNoticeById(row.id)
        if (data.code != 0) return
        this.contData = data.sysNotice
        this.$parent.$parent.$parent.getTipsNum()
      } else {
        const res = await findArticleInfo(row.id)
        this.contData = res.data.articleInformation
      }

    },
    goBackRemind() {
      this.flag = 1
      this.$parent.$parent.$parent.getTipsData()
      this.params.notificationType = '1'
      this.init()
      
    },
  },
}
</script>
<style lang='less' scoped>
#remind {
  padding: 0 25px;
  .remindTable {
    margin-top: 20px;
  }
  /deep/.el-table .cell {
    text-align: center;
  }
  .contTitle {
    margin: 25px 0;
    font-size: 24px;
    font-weight: 550;
    color: #6a707e;
    text-align: center;
  }
  .contCont {
    padding: 25px;
    cursor: pointer;
  }
}
</style>